export interface IMessageOrToastOptions {
    isOpen: boolean;
    variant: string;
    title: string;
    message: string;
    dismissable?: boolean;
    timeout?: number;
  }
  
  export const MessageorToastOptionsDefaultState: IMessageOrToastOptions = {
    isOpen: false,
    variant: 'success',
    title: '',
    message: ''
  }

  export const MessageOrToastWrongUsernameOrPassword: IMessageOrToastOptions = {
    isOpen: true,
    title: 'Check details',
    message: 'Username / password not recognised.',
    variant: 'error'
  }

  export const MessageOrToastConnectionError: IMessageOrToastOptions = {
    isOpen: true,
    title: 'Error',
    message: 'An error occurred. Please try again later',
    variant: 'error'
  }
  
  